import { yupResolver } from '@hookform/resolvers/yup';
import { TabPanel, TabView } from 'primereact/tabview';
import { useEffect, useMemo, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { WithData } from '../../../../../../types/api';
import { FormDataHub, HubType } from '../../../../../../types/api/hubs';
import {
  getInitialValues,
  getValidationSchema,
  tabIcon,
} from './CreateEditDialog.functions';
import GeneralInfo from './Tabs/GeneralInfo';
import ReconciliationIntervals from './Tabs/ReconciliationIntervals';
import Regions from './Tabs/Regions';
import WorkingHours from './Tabs/WorkingHours';

type Props = {
  data: WithData<HubType> | undefined;
  isEditDialog: boolean;
  handleSubmitForm: (data: FormDataHub) => void;
};

function FormContainer({ data, isEditDialog, handleSubmitForm }: Props) {
  const { t } = useTranslation();
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const validationSchema = useMemo(() => getValidationSchema(t), [t]);

  const defaultValues = useMemo(
    () => getInitialValues(data?.data, isEditDialog),
    [data?.data, isEditDialog]
  );

  const methods = useForm<FormDataHub>({
    resolver: yupResolver(validationSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    reset,
    getValues,
    formState: { errors },
  } = methods;
  console.log('getValues ', getValues());
  useEffect(() => {
    reset(defaultValues);
  }, [defaultValues, reset]);

  const generalInfoTabIcon = tabIcon('general-info', getValues(), errors);
  const regionsTabIcon = tabIcon('regions', getValues(), errors);
  const intervalsTabIcon = tabIcon('intervals', getValues(), errors);
  const workingHoursTabIcon = tabIcon('working-hours', getValues(), errors);

  return (
    <FormProvider {...methods}>
      <form id="hub-create-edit-form" onSubmit={handleSubmit(handleSubmitForm)}>
        <TabView
          activeIndex={activeTabIndex}
          onTabChange={(e) => setActiveTabIndex(e.index)}
          className={Object.keys(errors).length > 0 ? 'invalid' : ''}
        >
          <TabPanel header={t('General info')} {...generalInfoTabIcon}>
            <GeneralInfo />
          </TabPanel>

          <TabPanel header={t('Regions')} {...regionsTabIcon}>
            <Regions />
          </TabPanel>

          <TabPanel header={t('Intervals')} {...intervalsTabIcon}>
            <ReconciliationIntervals />
          </TabPanel>

          <TabPanel header={t('Working hours')} {...workingHoursTabIcon}>
            <WorkingHours />
          </TabPanel>
        </TabView>
      </form>
    </FormProvider>
  );
}

export default FormContainer;
